import { irMappingSlice } from "./irMappingSlice";
import * as defaultActions from "../../../../../redux/_common";
import * as fields from '../../pages/IRData/tabs/irMapping/edit/constants';

const { actions } = irMappingSlice;

export const setValidationErrors = actions.setValidationErrors;
const moduleUrl = '/api/imagerecognition/mapping'

export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);

export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );

export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);


export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);